import React from 'react';
import classnames from 'classnames';
import i18n from 'i18next';
import HighlightOff from '@mui/icons-material/HighlightOff';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';
import { createIconComponent } from 'uikit/icons';

import getAudienceType from '../helpers/getAudienceType';

import styles from '../styles/audienceChips.module.scss';

const AudienceChips = ({ audiences, isTypeOnly, onChipClick }) => {
  if (!audiences.length && isTypeOnly) {
    return (
      <div className={styles.chip}>
        <div className={classnames(styles.chipInner, styles.isEmpty)}>
          <Typo color="secondary" element="span" variant="b01">
            {i18n.t('determined-by-audience')}
          </Typo>
        </div>
      </div>
    );
  }

  return (
    <ul className={classnames(styles.element, isTypeOnly && styles.isTypeOnly)}>
      {audiences.map((audience) => {
        const type = getAudienceType(audience.audience_type);

        return (
          <li className={styles.chip} key={audience.id}>
            <div className={styles.chipInner}>
              {isTypeOnly &&
                createIconComponent({ icon: type.icon, className: styles.icon, size: 38 })}
              <div className={styles.text}>
                <Typo className={styles.text} element="span" variant="b01" weight="medium">
                  {isTypeOnly ? type.label : audience.name}
                </Typo>
                {!isTypeOnly && <Typo element="span" variant="b01">{` | ${type.label}`}</Typo>}
              </div>
              {!isTypeOnly && (
                <Button
                  ariaLabel={i18n.t('remove')}
                  className={styles.button}
                  icon={<HighlightOff />}
                  onClick={() => onChipClick(audience)}
                  size="xsmall"
                  variant="ghost"
                />
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default React.memo(AudienceChips);
